import React from 'react';
import PropTypes from 'prop-types';
import { Pressable, Switch as RNSwitch } from 'react-native-web';

import { colors } from '../../constants/globalStyles';
import styles, { SwitchStyles } from './styles';

/**
 * @typedef SwitchProps
 * @property {boolean} value
 * @property {keyof SwitchStyles} [variant]
 * @property {boolean} [disabled]
 * @property {() => void} onPress
 */
/** @type React.FC<SwitchProps> */
const Switch = ({ value, variant, disabled, onPress }) => {
  const { activeThumbColor, activeTrackColor } = SwitchStyles[variant];

  return (
    <Pressable style={styles.switchBody} onPress={onPress}>
      <RNSwitch
        value={value}
        disabled={disabled}
        trackColor={colors.white}
        thumbColor={colors.mediumGrey}
        activeThumbColor={activeThumbColor}
        activeTrackColor={activeTrackColor}
      />
    </Pressable>
  );
};

Switch.propTypes = {
  value: PropTypes.bool.isRequired,
  onPress: PropTypes.func.isRequired,
  variant: PropTypes.string,
};
Switch.defaultProps = {
  variant: 'default',
};

export default Switch;
